import Keycloak from 'keycloak-js'
import sortBy from 'lodash/sortBy'
import keycloakConfig from './keycloak.config'
import { authStore } from './auth-store'

const keycloak = new Keycloak({
  url: keycloakConfig.url,
  realm: keycloakConfig.realm,
  clientId: keycloakConfig.clientId,
})

const cleanupKeycloakUrl = () => {
  const url = new URL(window.location.href)
  const hasOauthParams =
    url.searchParams.has('code') ||
    url.searchParams.has('state') ||
    url.searchParams.has('session_state') ||
    url.searchParams.has('iss') ||
    url.searchParams.has('error')

  if (!hasOauthParams) {
    return
  }

  const cleanUrl = `${url.origin}${url.pathname}${url.hash || '#/'}`
  window.history.replaceState(window.history.state, '', cleanUrl)
}

export default {
  async init() {
    await keycloak.init({
      onLoad: 'check-sso',
      checkLoginIframe: false,
      useNonce: false,
      pkceMethod: 'S256',
      responseMode: 'query',
    })
    cleanupKeycloakUrl()
  },

  async login() {
    await keycloak.login()
  },

  async logout() {
    await keycloak.logout()
  },

  async loadUserProfile() {
    await keycloak.loadUserProfile()
  },

  hasRole(role: string) {
    return !!keycloak.authenticated && !!keycloak.realmAccess?.roles.includes(role)
  },

  getUser() {
    return keycloak.authenticated ? keycloak.tokenParsed : null
  },

  isAuthenticated() {
    const authenticated = keycloak.authenticated
    const store = authStore()

    if (authenticated) {
      const tokenParsed = this.getUser() as Record<string, any> | null
      const scopes = tokenParsed?.scope?.split(' ') ?? []
      const token = keycloak.token || ''

      localStorage.setItem('access_token', token)

      let roles = keycloak.realmAccess?.roles
      roles = roles?.filter(
        (role) =>
          role !== 'uma_authorization' &&
          role !== 'default-roles-godrive' &&
          role !== 'offline_access',
      )
      roles = sortBy(roles)

      const familyNameParts = tokenParsed?.family_name?.split(' ') ?? []
      const lastFamilyName = familyNameParts[familyNameParts.length - 1] ?? ''
      const letters = `${tokenParsed?.name?.charAt(0)?.toUpperCase() ?? ''}${lastFamilyName.charAt(0).toUpperCase()}`

      store.setDataKeycloak({
        authenticated,
        idToken: keycloak.idToken,
        token,
        refreshToken: keycloak.refreshToken,
        user: {
          letters,
          name: tokenParsed?.name,
          lastName: tokenParsed?.family_name,
          email: tokenParsed?.email,
          login: tokenParsed?.preferred_username,
          roles,
          scopes,
        },
      })
    }

    return authenticated
  },
}
